export function prettifyJSON(jsonString: string): string {
    return JSON.stringify(JSON.parse(jsonString), null, 2)
}

export function prettifyJSONFromList(jsonList: string[]): string {
    return JSON.stringify(jsonList, null, 2)
}

export function formatJson(jsonString: string, indentLevel: number, indentSize: number): string {
    let formattedString = "";
    let inString = false;

    for (let i = 0; i < jsonString.length; i++) {
        const char = jsonString[i];

        if (char === '"' && !isEscaped(jsonString, i)) {
            inString = !inString;
        }

        if (!inString) {
            if (char === "{" || char === "[") {
                formattedString += char + "\n" + " ".repeat(indentLevel + indentSize);
                indentLevel += indentSize;
            } else if (char === "}" || char === "]") {
                indentLevel = Math.max(indentLevel - indentSize, 0);
                formattedString += "\n" + " ".repeat(indentLevel) + char;
            } else if (char === ",") {
                formattedString += char + "\n" + " ".repeat(indentLevel);
            } else if (char === ":") {
                formattedString += char + " ";
            } else {
                formattedString += char;
            }
        } else {
            formattedString += char;
        }
    }

    return formattedString;
}

function isEscaped(str: string, index: number) {
    let escaped = false;
    for (let i = index - 1; i >= 0; i--) {
        if (str[i] === '\\') {
            escaped = !escaped;
        } else {
            break;
        }
    }
    return escaped;
}
